import { ExternalRedirect } from 'src/components/ExternalRedirect';

export const AuthRoutes = [
  {
    path: '/login',
    exact: true,
    component: (
      <ExternalRedirect
        to={`${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/login`}
      />
    ),
  },
  {
    path: '/logout',
    exact: true,
    component: (
      <ExternalRedirect
        to={`${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/logout`}
      />
    ),
  },
  {
    path: '/register',
    exact: true,
    component: (
      <ExternalRedirect
        to={`${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/login`}
      />
    ),
  },
  {
    path: '/passwordless-login',
    exact: true,
    component: (
      <ExternalRedirect
        to={`${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/login`}
      />
    ),
  },
  {
    path: '/recover',
    exact: true,
    component: (
      <ExternalRedirect
        to={`${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/recover`}
      />
    ),
  },
  {
    path: '/forgot_password*',
    exact: false,
    isPrivate: false,
    component: (
      <ExternalRedirect
        to={() => {
          const urlParams = new URLSearchParams(window.location.search);
          const code = urlParams.get('c');
          const user = urlParams.get('u');
          return `${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/change-password?code=${code}&user=${user}`;
        }}
      />
    ),
  },
];
